import { Card, Heading } from '@qga/roo-ui/components';
import { CONTACT_US_URL, FAQ_URL } from 'config/constants';
import * as track from 'lib/gaTracking/crossPageEvents';
import HelpItem from './HelpItem';

const NeedHelp = () => (
  <Card p={8} mb={8}>
    <Heading.h3 mb={0} fontWeight="normal" fontSize="2xl">
      Need help with your booking?
    </Heading.h3>
    <HelpItem
      title="Frequently asked questions"
      message="Can't find the information you're after? Browse our frequently asked questions for more help."
      linkLabel="Browse FAQs"
      link={FAQ_URL}
      onClick={track.completeFaqLinkSelected}
      mt={5}
    />
    <HelpItem
      title="Get in touch"
      message="Have questions about your credit voucher or recent cancellation? Chat with our customer support team online or via our contact centre."
      linkLabel="Contact us"
      link={CONTACT_US_URL}
      onClick={track.contactUsLinkSelected}
      mt={10}
    />
  </Card>
);

export default NeedHelp;
